<template>
  <div class="contact-page">
    <section class="contact-hero">
      <div class="contact-wrap">
        <div class="contact-badge">Get in Touch</div>
        <h1 class="contact-title">Request a Demo</h1>
        <p class="contact-subtitle">See how Enbarr's autonomous AI platform can transform your security operations.</p>
      </div>
    </section>

    <section class="contact-form-section">
      <div class="contact-wrap">
        <div class="contact-card">
          <form @submit.prevent="submitForm" class="contact-form">
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Name *</label>
                <input v-model="form.name" type="text" class="form-input" required placeholder="Your name" />
              </div>
              <div class="form-group">
                <label class="form-label">Email *</label>
                <input v-model="form.email" type="email" class="form-input" required placeholder="you@company.com" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Company</label>
                <input v-model="form.company" type="text" class="form-input" placeholder="Company name" />
              </div>
              <div class="form-group">
                <label class="form-label">Role</label>
                <input v-model="form.role" type="text" class="form-input" placeholder="Your role" />
              </div>
            </div>
            <div class="form-group form-group-full">
              <label class="form-label">Message *</label>
              <textarea v-model="form.message" class="form-input form-textarea" required placeholder="Tell us about your security needs..." rows="5"></textarea>
            </div>
            <div class="form-actions">
              <button type="submit" class="form-submit" :disabled="sending">
                {{ sending ? 'Sending...' : 'Send Message' }}
              </button>
              <p v-if="success" class="form-success">Message sent! We'll be in touch shortly.</p>
              <p v-if="error" class="form-error">{{ error }}</p>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {ref, reactive} from "vue";
import Axios from "axios";
export default {
    "name": "Contact",
    setup () {
        var form = reactive({
            name: "", email: "", company: "", role: "", message: ""
        });
        var sending = ref(false);
        var success = ref(false);
        var error = ref("");

        async function submitForm () {
            sending.value = true;
            success.value = false;
            error.value = "";
            try {
                await Axios.post(
                    (process.env.VUE_APP_SERVER_URI || "/") + "contact",
                    {
                        name: form.name,
                        email: form.email,
                        company: form.company,
                        role: form.role,
                        message: form.message
                    }
                );
                success.value = true;
                form.name = ""; form.email = ""; form.company = "";
                form.role = ""; form.message = "";
            } catch (e) {
                var msg = e.response && e.response.data && e.response.data.message;
                error.value = msg || "Something went wrong. Please try again or email contact@compdeep.com directly.";
            }
            sending.value = false;
        }

        return { form, sending, success, error, submitForm };
    }
};
</script>
<style scoped>
.contact-page {
  font-family: var(--font-body);
  color: var(--text-primary);
  background: var(--bg-primary);  font-size: 17px;
}

.contact-hero {
  padding: 160px 56px 60px;
  text-align: center;
}

.contact-wrap {
  max-width: 800px;
  margin: 0 auto;
}

.contact-badge {
  display: inline-block;
  padding: 10px 28px;
  margin-bottom: 24px;
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #fff;
  background: linear-gradient(135deg, #7c3aed 0%, #6366f1 45%, #06b6d4 100%);
  border-radius: 30px;
  box-shadow: 0 6px 24px rgba(236,72,153,0.4);
}

.contact-title {
  font-family: var(--font-heading);
  font-size: 3.5em;
  font-weight: 800;
  line-height: 1.1;
  margin: 0 0 20px;
  letter-spacing: -1.5px;
  background: linear-gradient(135deg, #5b21b6, #7c3aed 30%, #6366f1 60%, #06b6d4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.contact-subtitle {
  font-size: 1.2em;
  color: var(--text-secondary);
  line-height: 1.8;
  margin: 0;
}

.contact-form-section {
  padding: 0 56px 120px;
}

.contact-card {
  background: #fff;
  border-radius: 24px;
  padding: 52px 48px;
  border: 1px solid rgba(124,58,237,0.06);
  box-shadow: 0 10px 50px rgba(124,58,237,0.12);
}

.contact-form { display: flex; flex-direction: column; gap: 24px; }

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.form-group { display: flex; flex-direction: column; gap: 8px; }
.form-group-full { width: 100%; }

.form-label {
  font-family: var(--font-heading);
  font-size: 1.02em;
  font-weight: 700;
  color: var(--text-primary);
}

.form-input {
  padding: 16px 18px;
  font-family: var(--font-body);
  font-size: 1.08em;
  border: 2px solid rgba(124,58,237,0.1);
  border-radius: 12px;
  background: rgba(124,58,237,0.02);
  color: var(--text-primary);
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  outline: none;
}

.form-input:focus {
  border-color: #7c3aed;
  box-shadow: 0 0 0 4px rgba(124,58,237,0.1);
}

.form-input::placeholder { color: var(--text-secondary); opacity: 0.72; }

.form-textarea { resize: vertical; min-height: 120px; }

.form-actions { display: flex; align-items: center; gap: 20px; flex-wrap: wrap; }

.form-submit {
  padding: 16px 48px;
  font-family: var(--font-heading);
  font-size: 1.05em;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #7c3aed 0%, #6366f1 45%, #06b6d4 100%);
  border: none;
  border-radius: 30px;
  cursor: pointer;
  box-shadow: 0 8px 32px rgba(99,102,241,0.35);
  transition: transform 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease;
}

.form-submit:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 44px rgba(6,182,212,0.42);
}

.form-submit:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

.form-success { color: #059669; font-weight: 600; font-size: 1.02em; }
.form-error { color: #dc2626; font-weight: 600; font-size: 1.02em; }

:root[data-theme="dark"] .contact-card {
  background: rgba(20,15,40,0.92);
  border-color: rgba(124,58,237,0.2);
  box-shadow: 0 10px 50px rgba(0,0,0,0.35);
}

:root[data-theme="dark"] .form-input {
  background: rgba(124,58,237,0.06);
  border-color: rgba(124,58,237,0.2);
}

@media (max-width: 680px) {
  .contact-hero { padding: 120px 20px 40px; }
  .contact-form-section { padding: 0 20px 80px; }
  .contact-card { padding: 32px 24px; }
  .contact-title { font-size: 2.4em; }
  .form-row { grid-template-columns: 1fr; }
}
</style>
